<h1 class="page-title">Checkout and Pay</h1>
<app-product-list></app-product-list>
<form
    [formGroup]="checkoutForm"
    (ngSubmit)="onSubmit(checkoutForm.value)"
>
    <fieldset>
        <legend>Credit Card Payment</legend>
        <div class="field">
            <div class="field__label-input-wrap">
                <label
                    for="nameOnCard"
                    class="label"
                >
                    Name on Card
                </label>
                <input
                    class="input input--large"
                    [class.input--invalid]="formErrors.nameOnCard"
                    id="nameOnCard"
                    formControlName="nameOnCard"
                    maxlength="35"
                >
                <div
                    *ngIf="formErrors.nameOnCard"
                    class="error-message field__error-message"
                >
                    {{ formErrors.nameOnCard }}
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="field form-row__item form-row__item--medium">
                <div class="field__label-input-wrap">
                    <label
                        for="cardNumber"
                        class="label"
                    >
                        Card Number
                    </label>
                    <div
                        class="credit-card-number-input-wrap"
                        [class.credit-card-number-input-wrap--populated]="ccType"
                        [class.credit-card-number-input-wrap--amex]="ccType === cardTypes.Amex"
                        [class.credit-card-number-input-wrap--discover]="ccType === cardTypes.Discover"
                        [class.credit-card-number-input-wrap--mastercard]="ccType === cardTypes.MasterCard"
                        [class.credit-card-number-input-wrap--visa]="ccType === cardTypes.Visa"
                    >
                        <input
                            class="input input--medium"
                            [class.input--invalid]="formErrors.cardNumber"
                            formControlName="cardNumber"
                            id="cardNumber"
                            mask="0000 0000 0000 0000||0000 000000 00000"
                            [dropSpecialCharacters]="true"
                        >
                        <div
                            *ngIf="formErrors.cardNumber"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.cardNumber }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="expirationDate"
                        class="label"
                    >
                        Exp. Date
                    </label>
                    <input
                        class="input input--small"
                        [class.input--invalid]="formErrors.expirationDate"
                        formControlName="expirationDate"
                        id="expirationDate"
                        [dropSpecialCharacters]="true"
                        placeholder="MM/YY"
                        mask="00/00"
                    >
                    <div
                        *ngIf="formErrors.expirationDate"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.expirationDate }}
                    </div>
                </div>
            </div>
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="ccv"
                        class="label"
                    >
                        CCV
                    </label>
                    <input
                        class="input input--small"
                        [class.input--invalid]="formErrors.ccv"
                        formControlName="ccv"
                        id="ccv"
                        mask="000||0000"
                        placeholder="123"                        
                    >
                    <div
                        *ngIf="formErrors.ccv"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.ccv }}
                    </div>
                </div>
            </div>
        </div>
        <div class="field">
            <div class="field__label-input-wrap">
                <label
                    for="country"
                    class="label"
                >
                    Country
                </label>
                <select
                    class="input input--select-menu input--large"
                    [class.input--invalid]="formErrors.countryId"
                    id="country"
                    formControlName="countryId"
                >
                    <option value>Select One</option>
                    <option
                        *ngFor="let c of countries"
                        [value]="c.id"
                    >
                        {{c.description}}
                    </option>
                </select>
                <div
                    *ngIf="formErrors.countryId"
                    class="error-message field__error-message"
                >
                    {{ formErrors.countryId }}
                </div>
            </div>
        </div>
        <div class="field">
            <div class="field__label-input-wrap">
                <label
                    for="address"
                    class="label"
                >
                    Address
                </label>
                <input
                    class="input input--large"
                    [class.input--invalid]="formErrors.address"
                    id="address"
                    formControlName="address"
                    maxlength="35"
                >
                <div
                    *ngIf="formErrors.address"
                    class="error-message field__error-message"
                >
                    {{ formErrors.address }}
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="city"
                        class="label"
                    >
                        City
                    </label>
                    <input
                        class="input"
                        [class.input--invalid]="formErrors.city"
                        id="city"
                        formControlName="city"
                        maxlength="35"
                    >
                    <div
                        *ngIf="formErrors.city"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.city }}
                    </div>
                </div>
            </div>
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="state"
                        class="label"
                    >
                        State
                    </label>
                    <input
                        class="input"
                        [class.input--invalid]="formErrors.state"
                        id="state"
                        formControlName="state"
                        maxlength="50"
                    >
                    <div
                        *ngIf="formErrors.state"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.state }}
                    </div>
                </div>
            </div>
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="zip"
                        class="label"
                    >
                        Zip&#x2F;Postal Code
                    </label>
                    <input
                        class="input"
                        [class.input--invalid]="formErrors.zip"
                        id="zip"
                        formControlName="zip"
                        maxlength="10"
                    >
                    <div
                        *ngIf="formErrors.zip"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.zip }}
                    </div>
                </div>
            </div>
        </div>
        <p>
            By clicking Submit, I agree to pay {{purchase.total | currency: 'USD': true}} according to the cardholder agreement.
        </p>
        <div
            [hidden]="!serverMessage"
            id="serverMessage"
            class="error-message field__error-message"
        >
            {{serverMessage}}
        </div>
        <div class="form-actions">
            <input
                class="button form-actions__item"
                type="submit"
                value="Submit"
            >
            <button
                (click)="onCancel($event)"
                class="button button--secondary form-actions__item"
                type="button"
            >
                Cancel
            </button>
        </div>
    </fieldset>
</form>
